import React, { useEffect, useState } from 'react';
import { Widget } from '@typeform/embed-react';
import styles from './typeform.module.scss';
import { skipSurvey } from '@services/typeform';

/**
 * SurveyForm Component
 * Props:
 *  - surveyId: Typeform form ID to embed
 *  - userId: Unique identifier for the user (passed as hidden field)
 *
 * Renders an inline Typeform widget and a Skip button.
 * On skip, it sends a POST request to the /api/survey/:surveyId/skip endpoint.
 */
const SurveyForm = ({ surveyId, userId, handleForSubmit, handleSkip }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [showSkip, setShowSkip] = useState(false);

  useEffect(() => {
    const listener = (e) => {
      // only handle messages from Typeform
      if (!e.origin.includes('typeform.com') || !e.data?.type) return;

      switch (e.data.type) {
        case 'form-ready':
          // form iframe is fully loaded
          setIsLoaded(true);
          break;
        case 'form-submit':
          // user just submitted
          handleForSubmit();
          break;
      }
    };

    window.addEventListener('message', listener);
    return () => window.removeEventListener('message', listener);
  }, [handleForSubmit]);

  // When isLoaded flips to true, wait 5s then allow skip
  useEffect(() => {
    if (isLoaded) {
      const timer = setTimeout(() => setShowSkip(true), 3000);
      return () => clearTimeout(timer);
    }
  }, [isLoaded]);

  return (
    <div className={styles.surveyForm}>
      <div className={styles.head}>
        <p>👋 Hello, we would like to know <br /> your opinion</p>
        {showSkip && (
          <button onClick={handleSkip} className={styles.skipButton}>
            Skip Survey for now
          </button>
        )}
      </div>
      <Widget
        id={surveyId}
        style={{ width: '100%', height: '85vh' }}
        hidden={{ user_Id: `${userId}`, source: 'tickit.co' }}
        fullScreen={false}
        inlineOnMobile
      />
    </div>
  );
};

export default SurveyForm;
